// Отмена запросов фильтры +
// Отмена запросов таблицы + 
// Обработка ошибок таблица + 
// Квери + 

import { useDataTable } from '../../common/hooks';
import { FilterContainer } from '../../components/FilterContainer/FilterContainer';
import { useParams, useNavigate } from 'react-router-dom';
import { useState, useEffect, useCallback, useRef } from 'react';
import {
  TableBox,
  DropDownSelector,
  ButtonBasic,
} from '@lk-gtcom/ecomlab-components';
import './CalculationDelivery.scss';
import useGeneralStore from '../../store/general';
import customHeaders, { getSpace } from '../../common/headers';
import { fetchApiFilterVer3 } from '../../common/filtersFunc';
// Отмена запросов для фильтров
import { RequestController } from '../../common/filtersFunc';
import { TitlePage } from '../../components/TitlePage/TitlePage';
import { getValueMultiFilter } from '../../common/filtersFunc';
import { options_prop_mp } from '../../common/globalVariables';
import { TextPage } from '../../components/TextPage/TextPage';
import { useResponseHandler } from '../../common/auth';
import { useURLSearchParams } from '../../common/useURLSearchParams';
import { periodWeek } from '../../common/constant';
import { useSavedFilters } from '../../common/useSavedFilters';

const CalculationDelivery = () => {
  const selectedSpace = useGeneralStore((state) => state.selectedSpace);
  const headers = { ...customHeaders, ...getSpace(selectedSpace) };
  // Сохранённые фильтры: подставляются в URL при заходе, запись по кнопке
  const { isReady, saveFilters, clearSavedFilters, isSaved,  hasSavedFilters } = useSavedFilters(selectedSpace?.value, 'calculation-delivery');
  // Реф для хранения контроллера запросов
  const requestControllerRef = useRef(new RequestController());

  const [pageValue, setPageValue] = useState('');

  // Фильтры
  const filterConfig = [
    { key: 'mp', type: 'multi' },
    { key: 'api', type: 'multi' },
    { key: 'category', type: 'multi' },
    { key: 'brand', type: 'multi' },
    { key: 'warehouse', type: 'multi' },
  ];
  const { urlParams, updateURL, isInitialized, hasInitialParams } = useURLSearchParams(filterConfig);
  const [isFilterRequest, setIsFilterRequest] = useState(false);
  const { handleStatusCode, handleTableResponse, handleRequestError } = useResponseHandler();

  const [selectedMarketplace, setSelectedMarketplace] = useState([{ label: 'Все', value: 'all' }]);
  const [selectedApi, setSelectedApi] = useState([]);
  const [selectedWarehouse, setSelectedWarehouse] = useState([{ label: 'Все', value: 'all' }]);
  const [selectedCategory, setSelectedCategory] = useState([{ label: 'Все', value: 'all' }]);
  const [selectedBrand, setSelectedBrand] = useState([{ label: 'Все', value: 'all' }]);

  const [apiData, setApiData] = useState([]);
  const [warehouseData, setWarehouseData] = useState([]);
  const [categoryData, setCategoryData] = useState([]);
  const [brandData, setBrandData] = useState([]);

  const [apiPage, setApiPage] = useState(1);
  const [warehousePage, setWarehousePage] = useState(1);
  const [categoryPage, setCategoryPage] = useState(1);
  const [brandPage, setBrandPage] = useState(1);

  const [apiQuery, setApiQuery] = useState('');
  const [warehouseQuery, setWarehouseQuery] = useState('');
  const [categoryQuery, setCategoryQuery] = useState('');
  const [brandQuery, setBrandQuery] = useState('');

  const [totalApi, setTotalApi] = useState(0);
  const [totalCategory, setTotalCategory] = useState(0);
  const [totalBrand, setTotalBrand] = useState(0)
  const [totalWarehouse, setTotalWarehouse] = useState(0)

  const [daysValue, setDaysValue] = useState('7')
  const [targetIDCValue, setTargetIDCValue] = useState('30')

  // Таблица
  const [isTableRequest, setIsTableRequest] = useState(false);
  const paginatorRef = useRef();
  const [setTable, tableProps, setTableFuncs] = useDataTable(paginatorRef.current?.setTotal, paginatorRef);
  const { loading, sort, filters } = tableProps;
  const { setLoading, setFetchedData, setHeaders, setSort, setFilters } =
    setTableFuncs;

  const activeTab = useParams()['*'];

  // Инициализация фильтров из URL параметров при первом рендере
  const [isInitialLoadFromURL, setIsInitialLoadFromURL] = useState(false);

  useEffect(() => {
    if (!isReady) return;
    if (!isInitialLoadFromURL) {
      setIsInitialLoadFromURL(true);

      // Обновляем все состояния фильтров
      setTimeout(() => {
        if (urlParams.mp) setSelectedMarketplace(urlParams.mp)
        if (urlParams.api) setSelectedApi(urlParams.api)
        if (urlParams.category) setSelectedCategory(urlParams.category)
        if (urlParams.brand) setSelectedBrand(urlParams.brand)
        if (urlParams.warehouse) setSelectedWarehouse(urlParams.warehouse)

        // Запускаем запрос таблицы и фильтров только при первой инициализации из URL
        setIsFilterRequest(prev => !prev);
        if (Object.keys(urlParams).length > 0) {
          setIsTableRequest(prev => !prev);
        }
      }, 10);
    }
  }, [urlParams, isReady]);

  // Первая инициализация url
  useEffect(() => {
    if (!isReady) return;
    updateURL({
      mp: urlParams?.mp || selectedMarketplace,
      api: urlParams?.api || selectedApi,
      category: urlParams?.category || selectedCategory,
      brand: urlParams?.brand || selectedBrand,
      warehouse: urlParams?.warehouse || selectedWarehouse
    })
  }, [isReady]);

  const resetTable = () => {
    paginatorRef.current?.reset();
    paginatorRef.current?.setTotal(0);
    setSort({});
    setHeaders([]);
    setFetchedData([]);
  };

  // Таблица. По дням до поставки
  const fetchTableData = (params, abortController = new AbortController()) => {
    if (!selectedApi?.length) {
      resetTable()
      return
    }

    let sort, filters;
    if (params) {
      [sort, filters] = params;

    }
    setLoading(true);

    const url = `https://apps1.ecomru.ru:4450/api/v1/supply/calculation/table/days?days_before_delivery=${daysValue}&target_IDC=${targetIDCValue}${sort?.length > 0
      ? '&order_param=' + sort[0] + '&order_param_direction=' + sort[1]
      : ''
      }`

    const body = JSON.stringify({
      filters,
      page: paginatorRef.current?.page,
      limit: paginatorRef.current?.limit,
      category_id_list: getValueMultiFilter(selectedCategory),
      brand_id_list: getValueMultiFilter(selectedBrand),
      api_id_list: getValueMultiFilter(selectedApi),
      warehouse_id_list: getValueMultiFilter(selectedWarehouse),
    });

    fetch(url, { body, method: 'POST', headers, signal: abortController.signal })
      .then(res => {
        if (res.ok) {
          return res.json()
        } else {
          handleStatusCode(res.status)
        }
      })
      .then((json) => setTable(json))
      .catch(handleRequestError)
      .finally(() => {
        if (abortController.signal.aborted) return
        setLoading(false)
      })

  };

  const filtersApi = () => {
    const controller = requestControllerRef.current.createController('api');

    fetchApiFilterVer3({
      controller,
      selectedSpace: selectedSpace?.value,
      total: totalApi,
      page: apiPage,
      set: setApiData,
      searchParam: apiQuery,
      selectedApi,
      selectedShop: selectedMarketplace,
      setTotal: setTotalApi,
      filter: 'api_id',
    })?.finally(() => {
      requestControllerRef.current.removeController('api');
    })
  };

  const filtersWarehouse = () => {
    const controller = requestControllerRef.current.createController('warehouse');

    fetchApiFilterVer3({
      controller,
      selectedSpace: selectedSpace?.value,
      total: totalBrand,
      selectedApi,
      selectedCategory,
      selectedBrand,
      page: warehousePage,
      searchParam: warehouseQuery,
      selectedShop: selectedMarketplace,
      set: setWarehouseData,
      setTotal: setTotalWarehouse,
      filter: 'warehouse',
    })?.finally(() => {
      requestControllerRef.current.removeController('warehouse');
    })
  };

  const filtersCategory = () => {
    const controller = requestControllerRef.current.createController('category');

    fetchApiFilterVer3({
      controller,
      selectedSpace: selectedSpace?.value,
      total: totalCategory,
      page: categoryPage,
      apiData,
      selectedApi,
      set: setCategoryData,
      searchParam: categoryQuery,
      setTotal: setTotalCategory,
      filter: 'category',
    })?.finally(() => {
      requestControllerRef.current.removeController('category');
    })
  };

  const filtersBrand = () => {
    const controller = requestControllerRef.current.createController('brand');

    fetchApiFilterVer3({
      controller,
      selectedSpace: selectedSpace?.value,
      total: totalBrand,
      selectedApi,
      selectedCategory,
      page: brandPage,
      searchParam: brandQuery,
      selectedShop: selectedMarketplace,
      set: setBrandData,
      setTotal: setTotalBrand,
      filter: 'brand',
    })?.finally(() => {
      requestControllerRef.current.removeController('brand');
    })
  };

  useEffect(() => {
    if (!isInitialLoadFromURL) return;
    filtersApi();
  }, [isFilterRequest, apiPage, apiQuery]);

  useEffect(() => {
    if (!isInitialLoadFromURL) return;
    filtersWarehouse();
  }, [isFilterRequest, warehousePage, warehouseQuery]);

  useEffect(() => {
    if (!isInitialLoadFromURL) return;
    filtersCategory();
  }, [isFilterRequest, categoryPage, categoryQuery]);

  useEffect(() => {
    if (!isInitialLoadFromURL) return;
    filtersBrand();
  }, [isFilterRequest, brandPage, brandQuery]);

  useEffect(() => {
    return () => {
      // Отменяем все активные запросы фильтров
      requestControllerRef.current.abortAll();
    };
  }, []);

  useEffect(() => {
    setPageValue(activeTab);
  }, [activeTab]);

  useEffect(() => {
    if (!isReady) return
    const abortController = new AbortController();
    fetchTableData([], abortController)
    return () => abortController.abort();
  }, [isTableRequest]);

  return (
    <div className="calculation-delivery">
      <TitlePage
        title='Расчет поставки'
      />

      <FilterContainer
        loading={isSaved}
        saveFilters={saveFilters}
        clearSavedFilters={clearSavedFilters}
        hasSavedFilters={hasSavedFilters}
        onReset={(e) => {
          setSelectedApi([]);
          setSelectedCategory([]);
          setSelectedBrand([]);
          setSelectedWarehouse([]);
          updateURL({
            mp: null,
            api: null,
            category: null,
            brand: null,
            warehouse: null,
          });
          setIsTableRequest(!isTableRequest)
          setIsFilterRequest(!isFilterRequest);
        }}
      >
        <DropDownSelector
          options_prop={options_prop_mp}
          state={selectedMarketplace}
          setState={setSelectedMarketplace}
          placeholder="Площадка"
          total={options_prop_mp?.length}
          onBlur={() => {
            updateURL({ mp: selectedMarketplace });
            filtersApi();
            filtersCategory();
            filtersWarehouse();
            filtersBrand();
            setIsTableRequest(!isTableRequest)
          }}
        />

        <DropDownSelector
          state={selectedApi}
          options_prop={apiData}
          setState={setSelectedApi}
          placeholder="Магазин"
          total={totalApi}
          fetchCallback={setApiPage}
          setInputChange={setApiQuery}
          multi
          onBlur={() => {
            updateURL({ api: selectedApi });
            filtersCategory();
            filtersWarehouse();
            filtersBrand();
            setIsTableRequest(!isTableRequest);
          }}
        />

        <DropDownSelector
          options_prop={categoryData}
          state={selectedCategory}
          setState={setSelectedCategory}
          placeholder="Категория"
          total={totalCategory}
          fetchCallback={setCategoryPage}
          setInputChange={setCategoryQuery}
          multi
          onBlur={() => {
            updateURL({ category: selectedCategory });
            filtersWarehouse();
            filtersBrand();
            setIsTableRequest(!isTableRequest);
          }}
        />

        <DropDownSelector
          options_prop={brandData}
          state={selectedBrand}
          setState={setSelectedBrand}
          placeholder="Бренд"
          total={totalBrand}
          fetchCallback={setBrandPage}
          setInputChange={setBrandQuery}
          onBlur={() => {
            updateURL({ brand: selectedBrand });
            filtersWarehouse();
            setIsTableRequest(!isTableRequest);
          }}
          multi
        />

        <DropDownSelector
          options_prop={warehouseData}
          state={selectedWarehouse}
          setState={setSelectedWarehouse}
          placeholder="Склад"
          total={totalWarehouse}
          fetchCallback={setWarehousePage}
          setInputChange={setWarehouseQuery}
          multi
          onBlur={() => {
            updateURL({ warehouse: selectedWarehouse });
            setIsTableRequest(!isTableRequest);
          }}
        />
      </FilterContainer>

      <TableBox
        {...tableProps}
        paginator={true}
        ref={paginatorRef}
        onCheck={(e) => e}
        fetchCallback={fetchTableData}
        child={
          <div className="calculation-delivery__header-table">
            <label className="calculation-delivery__label">
              <TextPage
                text='Кол-во дней до поставки:'
                style={{
                  fontSize: '12px',
                  fontWeight: 600
                }}
              />

              <input
                min={0}
                value={daysValue}
                onChange={(e) => setDaysValue(e.target.value)}
                type="number"
                className="calculation-delivery__input"
              ></input>
            </label>

            <label className="calculation-delivery__label">
              <TextPage
                text='Целевой IDC:'
                style={{
                  fontSize: '12px',
                  fontWeight: 600
                }}
              />

              <input
                min={0}
                value={targetIDCValue}
                onChange={(e) => setTargetIDCValue(e.target.value)}
                type="number"
                className="calculation-delivery__input"
              ></input>
            </label>

            <ButtonBasic
              green
              size='32px'
              text="Рассчитать"
              disabled={!daysValue || !targetIDCValue}
              onClick={(e) => setIsTableRequest(!isTableRequest)}
            />
          </div>
        }
      />
    </div>
  );
};

export { CalculationDelivery };
